/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserSelfCreateRequest
 */
export interface OrgUserSelfCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfCreateRequest
     */
    join_org_pin?: string | null;
}

/**
 * Check if a given object implements the OrgUserSelfCreateRequest interface.
 */
export function instanceOfOrgUserSelfCreateRequest(value: object): value is OrgUserSelfCreateRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    return true;
}

export function OrgUserSelfCreateRequestFromJSON(json: any): OrgUserSelfCreateRequest {
    return OrgUserSelfCreateRequestFromJSONTyped(json, false);
}

export function OrgUserSelfCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserSelfCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'group_name': json['group_name'],
        'join_org_pin': json['join_org_pin'] == null ? undefined : json['join_org_pin'],
    };
}

export function OrgUserSelfCreateRequestToJSON(json: any): OrgUserSelfCreateRequest {
    return OrgUserSelfCreateRequestToJSONTyped(json, false);
}

export function OrgUserSelfCreateRequestToJSONTyped(value?: OrgUserSelfCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'group_name': value['group_name'],
        'join_org_pin': value['join_org_pin'],
    };
}

